import axios from 'axios'
import { Message } from 'element-ui'

export function setSingleImageSlimResource (refId:string) {
  return new Promise((resolve, reject) => {
    axios.post(`/index/image_slim/identify`, {
      ref_id: refId,
    }).then(({ data: res }) => {
      if (res.status == 0) {
        Message && Message.success('智能压缩成功')
        res.data.ref_id = res.data.rid
        resolve(res.data)
      } else {
        Message && Message.error(res.error)
        reject()
      }
    }).catch((error) => {
      Message && Message.error(error)
      reject()
    })
  })
  
}